import SolutionJobs from './SolutionJobs';

export { routes as solutionJobsRoutes } from './routes';
export default SolutionJobs;
